import React, { useEffect, useState } from "react";
import { useSite } from "../../context/SiteContext";
import { Menu, X } from "lucide-react";

const Nav = () => {
  const { nav, profile } = useSite();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-500 ${
        scrolled
          ? "bg-[#0a0a0a]/85 backdrop-blur-md border-b border-zinc-900"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <button
          onClick={() => go("top")}
          className="font-display text-lg md:text-xl tracking-tight text-stone-100 hover:text-amber-200 transition-colors"
        >
          {profile.firstName}
          <span className="text-amber-300">.</span>
          {profile.lastName}
        </button>

        <nav className="hidden md:flex items-center gap-9">
          {nav.map((n) => (
            <button
              key={n.id}
              onClick={() => go(n.id)}
              className="link-anim text-[13px] uppercase tracking-[0.18em] text-stone-300 hover:text-stone-50"
            >
              {n.label}
            </button>
          ))}
          <a
            href={`mailto:${profile.email}`}
            className="text-[13px] uppercase tracking-[0.18em] px-4 py-2 border border-stone-200/80 text-stone-100 hover:bg-stone-100 hover:text-zinc-950 transition-colors"
          >
            Hire me
          </a>
        </nav>

        <button
          className="md:hidden text-stone-100"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-zinc-900 bg-[#0a0a0a]">
          <div className="px-6 py-6 flex flex-col gap-5">
            {nav.map((n) => (
              <button
                key={n.id}
                onClick={() => go(n.id)}
                className="text-left text-sm uppercase tracking-[0.18em] text-stone-300"
              >
                {n.label}
              </button>
            ))}
            <a
              href={`mailto:${profile.email}`}
              className="text-sm uppercase tracking-[0.18em] text-amber-300"
            >
              Hire me →
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Nav;
